import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

export const DEFAULT_QUERY_DATA = {
    OrderNo: undefined,
    MemberId: undefined,
    MemberEmail: undefined,
    Status: undefined,
    DateStart: undefined,
    DateEnd: undefined,
};

export const generateQueryFormConfig = (): FormConfigType => [
    {
        title: "订单号",
        field: "OrderNo",
        type: "input",
        placeholder: "请输入订单号",
        style: { width: 200 },
    },
    {
        title: "用户ID",
        field: "MemberId",
        type: "inputNumber",
        placeholder: "请输入用户ID",
        style: { width: 160 },
    },
    {
        title: "用户邮箱",
        field: "MemberEmail",
        type: "input",
        placeholder: "请输入用户邮箱",
        style: { width: 200 },
    },
    {
        title: "状态",
        field: "Status",
        type: "select",
        placeholder: "请选择状态",
        options: [
            { name: "全部", id: undefined },
            { name: "处理中", id: 10 },
            { name: "失败", id: 20 },
            { name: "成功", id: 40 },
        ],
        style: { width: 160 },
    },
    {
        title: "创建时间",
        field: "DateRange",
        fields: ["DateStart", "DateEnd"],
        type: "rangePicker",
    },
];

export const orderStatusText = (status: number) => {
    const statusMap: Record<number, string> = {
        1: "预处理订单创建",
        2: "预处理订单成功",
        10: "处理中",
        20: "失败",
        40: "成功",
    };
    return statusMap[status] || "未知";
}

export const generateTableColumns = (): ColumnsType => [
    {
        title: "ID",
        dataIndex: "Id",
        key: "Id",
        width: 80,
    },
    {
        title: "订单号",
        dataIndex: "OrderNo",
        key: "OrderNo",
        width: 180,
    },
    {
        title: "用户ID",
        dataIndex: "MemberId",
        key: "MemberId",
        width: 100,
    },
    {
        title: "币种金额",
        key: "currencyAmount",
        render: (_: any, record: any) => `${record.CurrencyAmount || 0} ${record.CurrencyCode || ""}`,
    },
    {
        title: "USD金额",
        dataIndex: "UsdAmount",
        key: "UsdAmount",
    },
    {
        title: "服务费",
        dataIndex: "ServiceFee",
        key: "ServiceFee",
    },
    {
        title: "通道费",
        dataIndex: "ChannelFee",
        key: "ChannelFee",
    },
    {
        title: "总USD金额",
        dataIndex: "TotalUsdAmount",
        key: "TotalUsdAmount",
    },
    {
        title: "状态",
        dataIndex: "Status",
        key: "Status",
        render: orderStatusText,
    },
    {
        title: "上游预订单号",
        dataIndex: "UpstreamPreOrderNo",
        key: "UpstreamPreOrderNo",
    },
    {
        title: "上游订单号",
        dataIndex: "UpstreamOrderNo",
        key: "UpstreamOrderNo",
    },
    {
        title: "上游错误",
        dataIndex: "UpstreamErrMsg",
        key: "UpstreamErrMsg",
        width: 220,
    },
    {
        title: "银行名称",
        dataIndex: "BankName",
        key: "BankName",
    },
    {
        title: "银行账号",
        dataIndex: "BankAccountNumber",
        key: "BankAccountNumber",
    },
    {
        title: "创建时间",
        dataIndex: "CreatedAtString",
        key: "CreatedAtString",
    },
    {
        title: "更新时间",
        dataIndex: "UpdatedAtString",
        key: "UpdatedAtString",
    },
];
